import { render, staticRenderFns } from "./changeTime.vue?vue&type=template&id=85c898c2&scoped=true"
import script from "./changeTime.vue?vue&type=script&lang=js"
export * from "./changeTime.vue?vue&type=script&lang=js"
import style0 from "./changeTime.vue?vue&type=style&index=0&id=85c898c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c898c2",
  null
  
)

export default component.exports